import { useContext, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

import styles from './Drafts.module.css';

import { useAuth } from './Drafts.hooks';
import { Icon } from '../../components/icon/Icon';
import { useBackUrl } from '../../App.hooks';
import { AppContext } from '../../App.context';
import { Loading } from '../../components/loading/Loading';
import {
	NavbarIconLogo,
	ACCESS_TOKEN_EXPIRE_AT_KEY,
	USER_ROLE,
	ACCESS_TOKEN_KEY,
} from '../../constants';

import { AUTH_KEY } from './../home/auth/Authentication.hooks';

const Drafts = () => {
	return (
		<div className={styles['container']}>
			<View />
		</div>
	);
};

function View() {
	return (
		<div className={styles['view']}>
			<Topbar />
			<Content />
		</div>
	);
}

function Topbar() {
	return (
		<div className={styles['topbar']}>
			<div>
				<BackButton />
			</div>
			<div className={styles['title']}>
				<NavbarIconLogo />
			</div>
			<div></div>
		</div>
	);
}

function Content() {
	const isAdmin = localStorage.getItem(USER_ROLE) === 'admin';
	const [mode, setMode] = useState(
		localStorage.getItem(AUTH_KEY) ? 'logout' : 'login',
	);
	if (mode === 'logout' || isAdmin) {
		return <Logout setMode={setMode} />;
	}

	return <Login setMode={setMode} />;
}

function Login({ setMode }: AuthProps) {
	const [password, setPassword] = useState<string>('');
	const [credential, setCredential] = useState('');
	const { db, rebuildGraphQLClient } = useContext(AppContext);
	const { token, isLoading, error, expiredAt } = useAuth(credential);

	if (error) {
		console.log(`Error: `, error.message);
	}
	useEffect(() => {
		if (!token) {
			return;
		}

		if (!expiredAt) {
			return;
		}

		localStorage.setItem(AUTH_KEY, 'true');
		localStorage.setItem(USER_ROLE, 'admin');
		localStorage.setItem(ACCESS_TOKEN_KEY, token);
		localStorage.setItem(ACCESS_TOKEN_EXPIRE_AT_KEY, expiredAt);
		if (db) {
			db.clear();
		}
		rebuildGraphQLClient();
		setMode('logout');
	}, [token, expiredAt]);
	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		setCredential(password);
	};
	if (isLoading) {
		return (
			<div className={styles['content']}>
				<div>
					<Loading />
				</div>
			</div>
		);
	}

	if (error) {
		return (
			<div className={[styles['content'], styles['error']].join(' ')}>
				<form onSubmit={onSubmit}>
					<h4>Error</h4>
					<p>{error.message}</p>
					<input
						required
						onChange={(e) => {
							const { value } = e.target;
							setPassword(value);
						}}
						value={password}
						title="password"
						type={'password'}
					/>
					<button type={'submit'} title="Send">
						Send
					</button>
				</form>
			</div>
		);
	}

	return (
		<div className={styles['content']}>
			<form onSubmit={onSubmit}>
				<h4>Editor log in</h4>
				<p>Request credentials from your Account Manager</p>
				<input
					required
					onChange={(e) => {
						const { value } = e.target;
						setPassword(value);
					}}
					placeholder="Password"
					value={password}
					title="password"
					type={'password'}
				/>

				<button type={'submit'} title="Send">
					Send
				</button>
			</form>
		</div>
	);
}

function Logout({ setMode }: AuthProps) {
	const navigate = useNavigate();
	const { db } = useContext(AppContext);
	const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		const keys = [
			AUTH_KEY,
			USER_ROLE,
			ACCESS_TOKEN_KEY,
			ACCESS_TOKEN_EXPIRE_AT_KEY,
		];
		for (const k of keys) {
			if (localStorage.getItem(k)) {
				localStorage.removeItem(k);
			}
		}
		if (db) {
			db.clear();
		}
		setMode('login');
		window.location.reload();
	};

	return (
		<div className={styles['content']}>
			<form onSubmit={onSubmit}>
				<h4>You are currently logged in</h4>
				<p></p>
				<button
					onClick={() => {
						navigate('/', { replace: true });
					}}
					type="button"
					style={{ marginBottom: 20 }}
				>
					Go to Home
				</button>
				<button type={'submit'} title="Send">
					Log out
				</button>
				<small>Logging out will clear all stored data</small>
			</form>
		</div>
	);
}

interface AuthProps {
	setMode: any;
}

function BackButton() {
	const url = useBackUrl();
	return (
		<button id="back-button" type="button" title="Back">
			<Link to={url}>
				<Icon id={'back-btn'} name={'arrow-left'} color={'#333'} />
			</Link>
		</button>
	);
}

export function EyeIndicator() {
	const className = [styles['draft-icon'], 'tooltip down'].join(' ');
	const onClick = () => {
		window.location.replace('/drafts');
	};

	if (localStorage.getItem(ACCESS_TOKEN_KEY)) {
		return (
			<button
				type="button"
				className={className}
				data-text="Preview Mode"
				onClick={onClick}
			>
				<Icon name="eye" />
			</button>
		);
	}
	return null;
}

export default Drafts;
